import React from 'react';

function JobTitleSixteen(props) {
    return (
        <div>
            <h4 className='h4_font_16'>{props.title}</h4>
        </div>
    );
}

export default JobTitleSixteen;